module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', {
    attrs: {
      "for": "scriptNameEdit"
    }
  }, [_vm._v("Folder Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.name),
      expression: "value.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "value": "_Auto",
      "id": "scriptNameEdit",
      "placeholder": "Enter folder name"
    },
    domProps: {
      "value": (_vm.value.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "scriptNodeEdit"
    }
  }, [_vm._v("Node Path and Name (optional)")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "scriptNodeEdit",
      "autocomplete": "new-password",
      "preselect": "",
      "type": "text",
      "required": "",
      "placeholder": "Enter node or sector"
    }
  }), _vm._v(" "), _c('uiv-typeahead', {
    attrs: {
      "target": "#scriptNodeEdit",
      "async-function": _vm.sectorSearchFunction
    },
    model: {
      value: (_vm.value.nodePathAndName),
      callback: function($$v) {
        _vm.$set(_vm.value, "nodePathAndName", $$v)
      },
      expression: "value.nodePathAndName"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onSaveClick
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onCancelClick
    }
  }, [_vm._v("Close")])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f7b41498", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f7b41498"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/report-folder-editor-dialog/report-folder-editor-dialog.vue.html
// module id = 1136
// module chunks = 0